module.exports = __webpack_public_path__ + "img/united.45ba23a5.png";